import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleAlert } from 'Images';

export const IntroBubbleInfo = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.CompassRights
  ).introBubbleInfo;

  return (
    <Stack
      direction='row'
      borderRadius='8px'
      border={'1px solid'}
      borderColor={'primary.shade_200'}
      bgcolor={'primary.shade_100'}
      padding={isDesktop ? '24px 64px 24px 24px' : '12px'}
    >
      <Avatar
        alt=''
        src={PurpleAlert}
        sx={{ width: '20px', height: '20px', marginTop: '2px' }}
      />
      <Stack
        margin='0 0 0 7px'
        color={'text.secondary'}
        maxWidth={isDesktop ? 'initial' : '274px'}
      >
        <Typography variant={'body3'}>{dictionary.lineOne}</Typography>
        <Typography variant={'body3'}>{dictionary.lineTwo}</Typography>
      </Stack>
    </Stack>
  );
};
